// extracted by mini-css-extract-plugin
export default {"heading-primary":"Acronim_heading-primary__hjPcj","acronim":"Acronim_acronim__N-byp"};